import { Component } from "@kluntje/core";

class FRASearch extends Component {
  constructor() {
    super({
      ui: {
        overlay: ".fra-js-header__overlay :-one",
        input: ".fra-m-search__input :-one",
      },
      events: [
        {
          event: "fra-page-header-action-clicked",
          target: "window",
          handler: "handleHeaderActionClick",
        },
      ],
    });
  }

  /**
   * Handles events triggered by search action clicks.
   *
   * @param {CustomEvent<{ action: string }>} e - click event
   */
  handleHeaderActionClick(e: CustomEvent<{ action: string }>): void {
    if (e.detail.action !== "search") {
      return;
    }
    this.ui.overlay.open();
    this.ui.input.focus();
  }
}

customElements.define("fra-m-search", FRASearch);

export default FRASearch;
